module.exports = __webpack_public_path__ + "static/img/2422_phase_function_Paper_Points.c8301c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2422_phase_function_Paper_Points.png
// module id = l5qt
// module chunks = 0